import { Card, CardHeader, Stack, Typography, Box, Button, TextField, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Slide } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useState, useEffect, forwardRef } from 'react';
import PropTypes from 'prop-types';
import axiosInstance from '../../../hooks/axiosInstance';

const CHART_HEIGHT = 460;
const LEGEND_HEIGHT = 72;
const Transition = forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);
const StyledChartWrapper = styled('div')(({ theme }) => ({
  height: CHART_HEIGHT,
  marginTop: theme.spacing(2),
  '& .apexcharts-canvas svg': {
    height: CHART_HEIGHT,
  },
  '& .apexcharts-canvas svg,.apexcharts-canvas foreignObject': {
    overflow: 'visible',
  },
  '& .apexcharts-legend': {
    height: LEGEND_HEIGHT,
    alignContent: 'center',
    position: 'relative !important',
    borderTop: `solid 1px ${theme.palette.divider}`,
    top: `calc(${CHART_HEIGHT - LEGEND_HEIGHT}px) !important`,
  },
}));

AppDayNightSettings.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string,
  subheader2: PropTypes.string,
  deviceId: PropTypes.string,
  jwtToken: PropTypes.string,
};

export default function AppDayNightSettings({ title, color="secondary", subheader, subheader2, deviceId, jwtToken }) {
    const [setDayNightValue, setsetDayNightValue] = useState({ daystart: '', nightstart: ''});

    const [open, setOpen] = useState(false);
    const [msg, setmsg] = useState('');
    const [error, seterror] = useState(null);
    let callbackTimeout;

    useEffect(() => { const savedSetDayNightValue = localStorage.getItem('setDayNightValue'); 
        if (savedSetDayNightValue) setsetDayNightValue(JSON.parse(savedSetDayNightValue));}, 
        []);

    useEffect(() => {localStorage.setItem('setDayNightValue', JSON.stringify(setDayNightValue));}, [setDayNightValue]);

    const DayNightSetter = () => {
        axiosInstance
        .post(`/condition/setpoint/${deviceId}?jwt_token=${jwtToken}`, {
            daystart: setDayNightValue.daystart,
            nightstart: setDayNightValue.nightstart,
        })
        .then((res) => {
            if (res.status === 200) {
            clearTimeout(callbackTimeout);
            seterror(2);
            setmsg('Waiting for device processing...');
            const subEventSource = new EventSource(
                `https://demo.smartfarm.id/condition/get-events-callback/${deviceId}?jwt_token=${jwtToken}`
            );
            subEventSource.onmessage = (event) => {
                const data = JSON.parse(event.data);
                if (data.message === "Day Night time settings received") {
                setmsg('Day Night time settings received');
                seterror(0);
                subEventSource.close();
                clearTimeout(callbackTimeout);
                }
                callbackTimeout = setTimeout(() => {
                setmsg('Set point sent but not received well, try again later');
                seterror(1);
                subEventSource.close();
                }, 12000);
            };
            }
        })
        .catch((err) => {
            setmsg(err.response?.data?.msg || 'Unknown error');
            seterror(1);
        });
        setOpen(true);
    };

    return(
        <Card sx={{ p: 3,        
            color: (theme) => theme.palette[color].darker,
            bgcolor: (theme) => theme.palette[color].lighter}}>
            <CardHeader title={title} subheader={subheader} />
            <Stack spacing={3}>
                <Box textAlign="center">
                    <Typography variant="h5">Day/Night Time Settings</Typography>
                    <Typography variant="h9">24 Hour Format (00.00 - 23.59)</Typography>
                    <Stack spacing={2} mt ={2}>
                        {/* Condition Setter Section */}
                        <Stack spacing={2} >
                            <TextField
                            name="DayTime"
                            label="Day Start Time (HourHour . MinuteMinute)"
                            type="text"
                            value={setDayNightValue.daystart}
                            onChange={(e) => setsetDayNightValue({ ...setDayNightValue, daystart: e.target.value })}
                            sx ={{backgroundColor: "white",borderRadius: "8px","& .MuiInputBase-root": {backgroundColor: "white"}}}
                            />
                            <TextField
                            name="NightTime"
                            label="Night Night Time (HourHour . MinuteMinute)"
                            type="text"
                            value={setDayNightValue.nightstart}
                            onChange={(e) => setsetDayNightValue({ ...setDayNightValue, nightstart: e.target.value })}
                            sx ={{backgroundColor: "white",borderRadius: "8px","& .MuiInputBase-root": {backgroundColor: "white"}}}
                            />
                        </Stack>

                        <Button
                            fullWidth
                            variant="contained"
                            onClick={DayNightSetter}
                            disabled={Object.values(setDayNightValue).some((val) => !/^\d{1,2}\.\d{2}$/.test(val))}
                        >
                            Set Day/ Night Time
                        </Button>
                    </Stack>
                </Box>
            </Stack>

            {/* Dialog for Feedback */}
            <Dialog open={open} TransitionComponent={Transition} keepMounted onClose={() => setOpen(false)}>
                <DialogTitle>{error === 1 ? "Failure" : error === 0 ? "Success" : "Loading..."}</DialogTitle>
                <DialogContent>
                  <DialogContentText>{msg}</DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setOpen(false)}>Close</Button>
                </DialogActions>
            </Dialog>
        </Card>
    )
}